import { API_CONFIG } from '../../config/api';

export type TrendDirection = 'up' | 'down' | 'flat';

export interface GroupOverviewResponse {
  success: boolean;
  data: {
    group: {
      id: string;
      groupName: string;
      createdBy: any;
    };
    counts: {
      approvedMembers: number;
      withAssessments: number;
    };
    averages: {
      overall0to4: number;
      attributes0to4: Record<string, number>;
      attributesPercentage: Record<string, number>;
    };
    distribution: {
      high: number;
      moderate: number;
      low: number;
    };
    trends: Record<string, TrendDirection>;
    _debug?: {
      filterYear: string;
      userDimensions: Record<string, Record<string, number | null>>;
      assessmentCounts: Record<string, number>;
    };
  };
}

export const getGroupOverview = async (
  token: string,
  groupId: string,
  year?: number,
  mode: 'overall' | 'sowb' = 'sowb'
): Promise<GroupOverviewResponse> => {
  const params = new URLSearchParams();
  if (year) params.append('year', year.toString());
  params.append('mode', mode);
  const queryString = params.toString();
  const response = await fetch(`${API_CONFIG.ENDPOINTS.GROUPS}/${groupId}/overview?${queryString}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch group overview');
  }

  return data;
};


